import { FC } from "react"
import "./StateContainer.sass"
import { IStateContainer } from "./StateContainer.types"

export const StateContainer: FC<IStateContainer> = ({ text }) => (
  <div className="state-container">
    <p className="loading">{text}</p>
  </div>
)
